import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import { Typography } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles({
  footer: {
    position: 'fixed',
    height: '55px',
    bottom: '0px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'rgb(0, 0, 0)',
    background: 'rgb(255, 255, 255)',
    zIndex: 9999,
    // Prevent the user from selecting the text.
    userSelect: 'none',
    msUserSelect: 'none',
    msTouchSelect: 'none',
    WebkitUserSelect: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    cursor: 'default'
  },
  divider: {
    position: 'fixed',
    width: '86%',
    left: '7%',
    bottom: '56px'
  }
});

const Footer = () => {
  const classes = useStyles();

  return (
    <>
      <Divider className={classes.divider} />
      <footer className={classes.footer}>
        <Typography variant="h6">
          Made with <span role="img" aria-label="heart">❤️</span> by Team ASDF as part of the&nbsp;
          <Link
            href="https://euvsvirus.org/"
            target="_blank"
          >
            EUvsVirus Hackathon
          </Link>.
      </Typography>
      </footer>
    </>
  );
};

export default Footer;
